import { useRef } from "react";
import type { ProductFlatten } from "~/types";
import Neum from "../neum.component";

export function Gallery({ product }: { product: ProductFlatten }) {
  const modal = useRef<HTMLDivElement>(null);
  const modalImg = useRef<HTMLImageElement>(null);
  function showModal(src: string) {
    modal.current?.classList.add("flex");
    modal.current?.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
    if (modalImg.current) {
      modalImg.current.src = src;
    }
  }

  function closeModal() {
    document.getElementById("modal")?.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }

  return (
    <div>
      <div className="grid auto-rows-max grid-cols-12 gap-3 py-3">
        {product.images.map((productImg, index) => {
          return (
            <Neum className="col-span-12 w-full p-1" key={index}>
              <div className="p-0">
                <img
                  className="h-full w-full cursor-pointer rounded-lg object-cover sm:h-[520px] md:h-[520px]"
                  src={`${productImg.url as string}&width=520`}
                  alt={productImg.altText ?? ""}
                  onClick={() => {
                    showModal(productImg.url as string);
                  }}
                />
              </div>
            </Neum>
          );
        })}
      </div>
      <div
        id="modal"
        ref={modal}
        className="fixed left-0 top-0 z-50 hidden h-screen w-screen items-center  justify-center bg-black/70"
      >
        <p
          className="z-90 fixed right-8 top-6 cursor-pointer text-5xl font-bold text-white "
          onClick={() => {
            closeModal();
          }}
        >
          &times;
        </p>

        <img
          ref={modalImg}
          id="modal-img"
          src=""
          className="max-h-[600px] object-cover md:max-w-[800px]"
          alt="modalImg"
        />
      </div>
    </div>
  );
}
